import { Dispatch } from "redux";
import {
  getAllSalariesLog,
  getSalaryLogById,
  createSalaryLog,
  updateSalaryLog,
  deleteSalaryLog,
} from "../../services/SalaryMasterLogService";
import { SalaryMasterLog } from "../../types/SalaryMasterLog";

export enum SalaryActionLogList {
  ADD_SALARYLog = "ADD_SALARYLog",
  EDIT_SALARYLog = "EDIT_SALARYLog",
  FETCH_SALARIESLog = "FETCH_SALARIESLog",
  DELETE_SALARYLog = "DELETE_SALARYLog",
}

export interface AddSalaryLogAction {
  type: SalaryActionLogList.ADD_SALARYLog;
  data: SalaryMasterLog;
}

export interface EditSalaryLogAction {
  type: SalaryActionLogList.EDIT_SALARYLog;
  data: SalaryMasterLog;
  id: number;
}

export interface FetchSalaryLogAction {
  type: SalaryActionLogList.FETCH_SALARIESLog;
  data: SalaryMasterLog[];
}

export interface DeleteSalaryLogAction {
  type: SalaryActionLogList.DELETE_SALARYLog;
  data: number;
}

export type SalaryMasterLogActions =
  | AddSalaryLogAction
  | EditSalaryLogAction
  | FetchSalaryLogAction
  | DeleteSalaryLogAction;

export const addSalaryLogAction = (data: SalaryMasterLog) => {
  return async (dispatch: Dispatch) => {
    return createSalaryLog(data).then((res) => {
      if (res.status === 200 && res.data.data) {
        dispatch<AddSalaryLogAction>({
          type: SalaryActionLogList.ADD_SALARYLog,
          data: res.data,
        });

        return res.data.message;
      }
    });
  };
};

export const editSalaryLogAction = (id: number, data: SalaryMasterLog) => {
  return async (dispatch: Dispatch) => {
    return updateSalaryLog(id, data).then((res) => {
      if (res.status === 200 && res.data.data) {
        dispatch<EditSalaryLogAction>({
          type: SalaryActionLogList.EDIT_SALARYLog,
          data: res.data,
          id,
        });

        return res.data.message;
      }
    });
  };
};

export const fetchSalariesLogAction = () => {
  return async (dispatch: Dispatch) => {
    const res = await getAllSalariesLog();

    dispatch<FetchSalaryLogAction>({
      type: SalaryActionLogList.FETCH_SALARIESLog,
      data: res,
    });
  };
};

export const deleteSalaryLogAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    return deleteSalaryLog(id).then((res) => {
      if (res.status === 200) {
        dispatch<DeleteSalaryLogAction>({
          type: SalaryActionLogList.DELETE_SALARYLog,
          data: id,
        });
        return res.data.message;
      }
    });
  };
};
